import React, { useState } from 'react';
import Select, { StylesConfig, components } from 'react-select';
import styles from './HeaderButtons.module.css';


interface HeaderButtonsProps {

}

export const HeaderButtons: React.FC<HeaderButtonsProps> = () => {

    return (
        <div className={styles.buttonsContainer}>

        </div>
    );
};
